// Validación de los datos del formulario público.
//
// Duplicadas a propósito de server/lib/validar.js: aquí sirven para avisar
// mientras se rellena, sin ir al servidor. El servidor vuelve a comprobarlo
// todo y es el que manda.
// Si cambias una regla, cámbiala en los dos sitios.

// Letras de control del DNI, en el orden que define el algoritmo (número % 23).
const LETRAS_DNI = 'TRWAGMYFPDXBNJZSQVHLCKE';

/**
 * DNI (8 dígitos + letra) o NIE (X/Y/Z + 7 dígitos + letra).
 * Comprueba también la letra de control, que es lo que caza las erratas.
 */
export function dniValido(valor) {
  const limpio = String(valor || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
  const partes = /^([XYZ]?)(\d+)([A-Z])$/.exec(limpio);
  if (!partes) return false;

  const [, prefijo, numero, letra] = partes;
  if (prefijo ? numero.length !== 7 : numero.length !== 8) return false;

  // En el NIE la letra inicial cuenta como un dígito: X=0, Y=1, Z=2.
  const base = prefijo ? `${'XYZ'.indexOf(prefijo)}${numero}` : numero;
  return LETRAS_DNI[Number(base) % 23] === letra;
}

/** Deja el DNI en su forma canónica: sin espacios ni guiones y en mayúsculas. */
export function formatearDni(valor) {
  return String(valor || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
}

export function emailValido(valor) {
  const limpio = String(valor || '').trim();
  return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(limpio) && limpio.length <= 254;
}

/** Al menos 9 dígitos, con prefijo internacional opcional. */
export function telefonoValido(valor) {
  const digitos = String(valor || '').replace(/\D/g, '');
  return digitos.length >= 9 && digitos.length <= 15;
}

/**
 * "La Cocina de María" → "@lacocinademaria"
 * Igual que la de server/lib/normalizar.js: Instagram y TikTok solo admiten
 * letras sin tilde, dígitos, guion bajo y punto; YouTube, además, el guion.
 */
export function normalizarUsuario(valor, plataforma) {
  const sobra = plataforma === 'YouTube' ? /[^a-z0-9._-]/g : /[^a-z0-9._]/g;
  const limpio = String(valor || '')
    .trim()
    .replace(/^@+/, '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(sobra, '');
  return limpio ? `@${limpio}` : '';
}

/** "mayte hidalgo de la rodriguez" → "Mayte Hidalgo De La Rodriguez" */
export function tituloSimple(valor) {
  return String(valor || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/(^|\s)\S/g, (letra) => letra.toUpperCase());
}
